<template>
  <tr :class="theme">
    <td :colspan="colsCount" class="delivery-group-separator-cell">
      <div class="delivery-group-separator">
        <OurSvgIcon :src="icons.Truck" size="xs" color="gray" />
        <span class="delivery-group-separator__text">
          {{ $t("page.cart.deliveryUntil", { date: formattedDate }) }}
          <span class="delivery-group-separator__dot">•</span>
          {{ warehouse }}
        </span>
      </div>
    </td>
  </tr>
</template>

<script>
import DateService from "@/services/date.service";
import { getThemeClass } from "@/services/_bit/UiService";

export default {
  name: "DeliveryGroupSeparator",

  props: {
    date: {
      type: [Number, String],
      default: 0,
    },

    warehouse: {
      type: String,
      default: "",
    },

    colsCount: {
      type: Number,
      default: 1,
    },
  },

  computed: {
    icons: () => ({
      Truck: require("@material-symbols/svg-400/outlined/local_shipping.svg"),
    }),

    formattedDate() {
      if (!this.date) {
        return "";
      }

      return DateService.dateConverter(Number(this.date), "date");
    },

    theme() {
      return getThemeClass();
    },
  },
};
</script>

<style lang="postcss" scoped>
.delivery-group-separator-cell {
  @apply p-0 !important;
}

.delivery-group-separator {
  @apply mx-5 my-2 flex items-center gap-2 rounded-md bg-gray-100 px-4 py-2 text-sm text-gray-500;

  &__text {
    @apply flex flex-wrap items-center gap-1;
  }

  &__dot {
    @apply text-gray-900;
  }
}
</style>
